import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { RegularButton } from "@/stories/button/button";
import { CircleCheck } from "lucide-react";

interface PaymentStepProps {
    successStr: string;
    onClose: (value: boolean) => void;
}

const SuccessModal: React.FC<PaymentStepProps> = ({ successStr, onClose }) => {
    const [isOpen, setIsOpen] = useState(true);

    const onClosePopup = () => {
        setIsOpen(false);
        onClose(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClosePopup}>
            <DialogDescription>{successStr}</DialogDescription>
            <DialogContent className="w-[90%] rounded-2xl p-9 md:w-[460px]">
                <VisuallyHidden.Root>
                    <DialogTitle>Success Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full">
                    <div className="flex w-full">
                        <CircleCheck className="m-auto h-8 w-8 text-green-500" />
                    </div>
                    <div className="w-full text-center text-xl font-semibold">
                        <div className="flex flex-col items-center justify-center py-3">
                            Success
                        </div>
                    </div>
                    <div className="flex-center flex flex-col items-center">
                        <p className="w-full text-center text-md">{successStr}</p>
                    </div>
                </div>
                <RegularButton
                    className="h-16 max-w-full text-lg md:mt-8"
                    label="Ok"
                    noIcon={true}
                    showRightIcon={false}
                    onClick={onClosePopup}
                />
            </DialogContent>
        </Dialog>
    );
};

export default SuccessModal;
